// Author yujiabei
// Date 2021-06-28 18:04:55

class EmAdmFactoryModelTypeEafmt {
constructor({
        id = null,
        eafmtName = '',
        eafmtRemark = ''}
= {}) {
    this.id = id;
    this.eafmtName = eafmtName;
    this.eafmtRemark = eafmtRemark;
}
}

function newEntity() {
return new EmAdmFactoryModelTypeEafmt();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.em.admin.emAdmFactoryModelTypeEafmt.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'eafmtName',
        label: 'label.em.admin.emAdmFactoryModelTypeEafmt.grid.eafmtName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'eafmtRemark',
        label: 'label.em.admin.emAdmFactoryModelTypeEafmt.grid.eafmtRemark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    idFilter : "",
    idListFilter : "",
    eafmtNameFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'eafmtNameFilter',
        label: 'label.em.admin.emAdmFactoryModelTypeEafmt.filter.eafmtName',
        disabled: false,
        form: {
        type: 'input'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'eafmtName',
        label: 'label.em.admin.emAdmFactoryModelTypeEafmt.entity.eafmtName',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'eafmtRemark',
        label: 'label.em.admin.emAdmFactoryModelTypeEafmt.entity.eafmtRemark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {EmAdmFactoryModelTypeEafmt, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
